export const headerData = {
  employees: 3,
  fx: 4,
  cotton: 16,
  wheat: 12,
};

export const mocknames = [
  {
    id: 1,
    teachers: 'Jo‘rayev Sardor Bahromovich',
    students: 20,
  },
  {
    id: 2,
    teachers: 'Umidov Anvar Vahobovich',
    students: 18,
  },
  {
    id: 3,
    teachers: 'Xolmatov Diyor Doniyorovich',
    students: 19,
  },
  {
    id: 4,
    teachers: 'Xolmatov Diyor Doniyorovich',
    students: 18,
  },
];
